<template>
  <div>
    <img
      v-if="typeof signedUrl === 'string'"
      :src="signedUrl"
      @click="handleClick"
      :class="[type === 'small' ? 'thumbnail' : '', { clickable }]"
    />
    <teleport to="body">
      <div
        v-if="showModal"
        class="modal fade show signed-image-modal"
        tabindex="-1"
        role="dialog"
        aria-modal="true"
      >
        <div class="modal-backdrop fade show" @click="closeModal"></div>
        <div
          class="modal-dialog modal-dialog-centered modal-lg custom-gfb-modal-thumbnail"
          @click.stop
        >
          <div class="modal-content modal-no-padding" @click.stop>
            <div class="image-card">
              <div v-if="isLoading" class="spinner"></div>
              <img
                v-else
                :src="modalImageUrl"
                class="modal-image"
                @load="isLoading = false"
              />
              <div v-if="!isLoading" class="close-button-container">
                <button class="close-button" @click="closeModal">Close</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </teleport>
  </div>
</template>

<script>
import file from "@/api/file.js"

export default {
  name: "signed-image",
  props: {
    file: {
      type: [String, Object],
      required: true,
    },
    type: {
      type: String,
      default: "",
    },
    clickable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      signedUrl: typeof this.file === "string" ? this.file : null,
      showModal: false,
      modalImageUrl: "",
      isLoading: false,
    }
  },
  mounted() {
    this.loadFile()
  },
  methods: {
    async loadFile() {
      if (!this.file) return

      try {
        let fileId = null
        const isThumbnail = this.type === "small" || this.type === "large"

        if (typeof this.file === "object" && this.file._id) {
          fileId = this.file._id
        }

        if (fileId) {
          const { data } = isThumbnail
            ? await file.getThumbnailUrl({ id: fileId, type: this.type })
            : await file.getFileUrl({ id: fileId })

          if (data?.url) {
            this.signedUrl = data.url
          } else if (data?.errors) {
            console.error(data.errors[0])
          }
        } else if (typeof this.file === "string") {
          this.signedUrl = this.file
        }
      } catch (error) {
        if (process.env.NODE_ENV === "development") {
          console.error(error)
        }
      }
    },
    async handleClick() {
      if (
        !this.clickable ||
        !this.file ||
        typeof this.file !== "object" ||
        !this.file._id
      )
        return

      try {
        this.isLoading = true // ← Start loading

        const { data } = await file.getThumbnailUrl({
          id: this.file._id,
          type: "large",
        })

        if (data?.url) {
          this.modalImageUrl = data.url
          this.showModal = true
        } else if (data?.errors) {
          console.error(data.errors[0])
        }
      } catch (error) {
        if (process.env.NODE_ENV === "development") {
          console.error(error)
        }
      } finally {
        this.isLoading = false // ← End loading regardless of success/failure
      }
    },

    closeModal() {
      this.showModal = false
      this.modalImageUrl = ""
      this.isLoading = false
    },
  },
  watch: {
    file: {
      handler() {
        this.loadFile()
      },
      deep: true,
    },
    type() {
      this.loadFile()
    },
  },
}
</script>

<style lang="scss" scoped>
.signed-image-modal {
  position: fixed;
  inset: 0;
  z-index: 1060;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.signed-image-modal .modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1040;
}

.signed-image-modal .modal-dialog {
  position: relative;
  z-index: 1055;
  margin: 0;
  max-width: 90vw;
}

.signed-image-modal .modal-content {
  border: 0;
  background: transparent;
  box-shadow: none;
}

.thumbnail {
  min-height: 200px;
  max-height: 200px;
  min-width: 200px;
  object-fit: contain;
  cursor: pointer;
  border-radius: 22px;
  border: 1px solid #b0b9c9;
}

.clickable {
  cursor: pointer;
}

.custom-modal {
  padding: 0 !important;
  background: transparent;
}
.modal-container {
  display: block !important;

  border-radius: 20px;
  background-color: transparent !important;
}
.modal-content-thumbnail {
  background-color: #ffffff00 !important;
  border-radius: 17px;
  width: auto !important;
}
.image-card {
  background: white;
  border-radius: 12px;
  border: 2px solid #b0b9c9;
  padding: 16px;
  max-width: 100%;
  text-align: center;
}

.modal-image {
  max-width: 100%;
  max-height: 60vh;
  border-radius: 8px;
  margin-bottom: 16px;
}

.close-button-container {
  display: flex;
  justify-content: center;
}

.close-button {
  background-color: #009dff;
  color: white;
  border: none;
  border-radius: 20px;
  padding: 8px 24px;
  font-size: 16px;
  cursor: pointer;
}
.spinner {
  width: 50px;
  height: 50px;
  margin: 50px auto;
  border: 5px solid #ccc;
  border-top: 5px solid #009dff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@media (max-width: 768px) {
  .thumbnail {
    min-height: 100px;
    min-width: 100px;
  }

  .image-card {
    padding: 8px;
  }

  .modal-image {
    max-height: 40vh;
  }

  .close-button {
    font-size: 14px;
    padding: 6px 18px;
  }
}
</style>
